import PaginationData from '@/helpers/PaginationData';
import { FormDataDeliveryCharge } from '@/form/form-data/FormDataDeliveryCharge';
import { distance, } from './types';
export const initState = () => ({
    /** 초기값 숨김 */
    toggleForm: false,
    isEdit: false,
    storeDetail: null,
    selectedItem: null,
    checkedList: [],
    filterOption: {
        pageSizeType: 20,
        searchWord: {
            /** 검색유형 */
            field: '',
            /** 검색어 */
            value: '',
        },
    },
    /** 배대료 다이얼로그 오픈 여부 */
    isDeliveryChargeDialogOpen: false,
    /** 구역설정 다이얼로그 오픈 여부 */
    isAreaDialogOpen: false,
    /** 구분 */
    chargeType: distance,
    /** 대행료 설정 */
    formData: new FormDataDeliveryCharge(),
    /** 원본 값 */
    originFormData: new FormDataDeliveryCharge(),
    /** 선택한 구역 데이터 */
    selectedArea: null,
    deliveryChargeList: [],
    paginationData: new PaginationData(),
});
const state = initState();
export default state;
